import { NavLink } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import type { IHomeMenuLinkProps } from './IHomeMenuLinkProps';

/** Пункт лівого меню Головної (UIUX left-menu): 32px · 14px · відступ 22px, лічильник IBM Plex Mono 11px праворуч, активний — --accent-soft і акцентний текст (без жирності, як у прототипі v4). */
export function HomeMenuLink({ to, label, count, warning, end }: IHomeMenuLinkProps) {
  return (
    <NavLink className={({ isActive }) => cx('mnav__item hm-item', isActive && 'is-active')} to={to} end={end}>
      <span className="mnav__label" title={label}>{label}</span>
      {count !== undefined && <span className={cx('mnav__count', warning && count > 0 && 'is-warning')}>{count}</span>}
    </NavLink>
  );
}
